

export interface CoreEduCloudConfiguration {
    id: string
    customerId?: string
    clientId?: string
    clientSecret?: string
    municipalityCode?: string
    schoolOrganizationType: EduCloudSchoolOrganizationType
    activityNaming: EduCloudActivityNaming
    includeSensitiveFields: EduCloudIncludeSensitiveFields
}

export enum EduCloudSchoolOrganizationType {
    Undefined = 0,
    School = 1,
    SchoolUnit = 2,
}

export enum EduCloudActivityNaming {
    Undefined = 0,
    ActivityDisplayName = 1,
    GroupDisplayName = 2,
}

enum EduCloudIncludeSensitiveFields {
    None = 0x0000,
    Address = 0x0001,
    CivicNo = 0x0002,
    PersonalEmail = 0x0004,
    Custodian = 0x0008,
    BirthDate = 0x0010,
    PhoneNumber = 0x0020,
    Sex = 0x0040,
}

export const EduCloudIncludeSensitiveFieldsOptions: EduCloudIncludeSensitiveFields[] = [
    EduCloudIncludeSensitiveFields.Address,
    EduCloudIncludeSensitiveFields.CivicNo,
    EduCloudIncludeSensitiveFields.PersonalEmail,
    EduCloudIncludeSensitiveFields.Custodian,
    EduCloudIncludeSensitiveFields.BirthDate,
    EduCloudIncludeSensitiveFields.PhoneNumber,
    EduCloudIncludeSensitiveFields.Sex
];

export const EduCloudSchoolOrganizationTypeOptions: EduCloudSchoolOrganizationType[] = [
    EduCloudSchoolOrganizationType.School,
    EduCloudSchoolOrganizationType.SchoolUnit
];

export const EduCloudActivityNamingOptions: EduCloudActivityNaming[] = [
    EduCloudActivityNaming.ActivityDisplayName,
    EduCloudActivityNaming.GroupDisplayName
];
